import { getAbTestAnalyticsEntries } from 'helpers/getAbTestAnalyticsEntries'
import type { TRemoteConfigVariantData } from 'helpers/getRemoteConfigVariantData'
import { Cohort } from 'root-constants'

export const getAbTestOptions = ({
  cohort,
  country,
  remoteConfigVariantValue,
}: {
  cohort: Cohort
  remoteConfigVariantValue: TRemoteConfigVariantData
  country: string // will be needed for other cohorts
}): Record<string, string> =>
  Object.fromEntries(
    getAbTestAnalyticsEntries({
      cohort,
      country,
      remoteConfigVariantData: remoteConfigVariantValue,
    }).map(({ key, value }) => [key, value]),
  )
